<template>
   <div>
       <template slot="title">
        <h6 class="colorEmision">Emision</h6>
        <div class="separador"></div>
      </template>
      <b-card bg-variant="light">
        <template slot="header" class="text-center">
            <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                    <h3><b>Proforma</b></h3>
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                  <b-input-group>
                      <template v-if="seriesCargadas">
                        <b-button size="md" variant="secondary" outline-success>
                          Cargando Series... <i class="fa fa-spin fa-spinner"></i>
                        </b-button>
                      </template>
                      <template v-else>
                        <select class="form-control input-placedark input-dark colorBorde" v-model="indexSerie">
                          <option v-for="(serie, index) in listaSeries" :value="index" :key="index">{{ serie }}</option>
                        </select>
                      </template>
                    </b-input-group>
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                  <b-form-select class="colorBorde" v-model="moneda">
                      <option :value="moneda" v-for="moneda in tipoMoneda" v-bind:key="moneda.id">
                          {{ moneda.descripcion }}
                      </option>
                  </b-form-select>
                </b-col>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2"  >
                  <datepicker
                    style="border-radius:4px;border:1px solid #012171"
                    v-model="fechaEmisionProforma"
                    :format="customFormatter"
                    :language="es"
                    :bootstrap-styling="true"
                    :disabledDates="diasnopermitidos"
                    :placeholder="currentdate">
                  </datepicker>
                </b-col>
            </b-row>
        </template>
        <b-row>
            <b-col cols="12" sm="7"	md="7"	lg="7"	xl="7">
              <em><strong>Para:</strong></em><br>
              <b-row align-v="center" class="mb-1">
                <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                  Documento:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="3"	xl="3">
                  <b-form-select class="colorBorde" v-model="tipoDocumento">
                      <option :value="tipodocumento.tipo" v-for="tipodocumento in documentosIdentidad" v-bind:key="tipodocumento.tipo">
                          {{ tipodocumento.nombre }}
                      </option>
                  </b-form-select>
                </b-col>
                <b-col cols="12" sm="8"	md="8"	lg="8"	xl="6">
                  <b-input-group>
                    <b-form-input 
                      v-model="receptor.numero" 
                      class="text colorBorde" 
                      @change="getReceivers(1)">
                    </b-form-input>
                    <b-input-group-text class="colorBorde" slot="append">
                        <b-button 
                          size="sm" 
                          variant="warning" 
                          class="m-0 p-0" 
                          @click="enableFieldsReceptor">
                          <i class="fa fa-search ml-1 mr-1"></i>
                        </b-button>
                    </b-input-group-text>
                  </b-input-group>
                  <template v-if="cargandoreceptor">
                    <b-list-group class="searcher-field">
                      <b-list-group-item>Buscando <i class="fa fa-spin fa-spinner"></i></b-list-group-item>
                    </b-list-group>
                  </template>
                  <b-list-group v-if="listarec" class="searcher-field">
                    <template v-for="(item, index) in listaReceptores" class="buscarRuc">
                      <b-list-group-item :key="index" @click="setReceiver(item)" class="searcher-result">
                        {{item.idReceptor + ' - ' + item.razonSocial}}
                      </b-list-group-item>
                    </template>
                  </b-list-group>
                  <b-list-group v-if="mostrardni" class="searcher-field">
                      <b-list-group-item v-if="norecdni">No hay Receptores con ese número</b-list-group-item>                                 
                      <template >
                          <b-list-group-item  @click="setReceiverdni(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                      </template> 
                  </b-list-group>  
                </b-col>
              </b-row>
              <b-row align-v="center" class="mb-1">
                <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                  Razon Social:
                </b-col>
                <b-col cols="12" sm="8"	md="8"	lg="8"	xl="9">
                  <b-input 
                    class="colorBorde"
                    v-model="receptor.razonSocial" 
                    @change="getReceivers(2)" 
                    placeholder="Ingresa razon social">
                  </b-input>
                </b-col>
              </b-row>
              <b-row align-v="center">
                <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                  Direccion:
                </b-col>
                <b-col cols="12" sm="8"	md="8"	lg="8"	xl="9">
                  <b-input-group>
                      <b-form-input
                        class="colorBorde"
                        type="text" 
                        v-model="receptor.direccion" 
                        :value="receptor.direccion" 
                        placeholder="Ingrese Dirección">
                      </b-form-input>
                      <b-input-group-text class="colorBorde" slot="append">
                          <button 
                            class="btn btn-warning btn-sm sinresultados" 
                            @click="changeDirection()">
                            <i class="fa fa-list"></i>
                          </button>
                      </b-input-group-text>
                  </b-input-group>
                  <template v-if="verDirecciones">
                      <template v-for="(item, index) in direcciones" class="buscarRuc">
                          <b-list-group-item :key="index" @click="setDirection(item)" class="searcher-result">
                          {{item.direccion}}
                          </b-list-group-item>
                      </template>
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="5"	md="5"	lg="5"	xl="5">
              <em><strong>Detalles:</strong></em><br>
              <b-row align-v="center" class="mb-1">
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="12">
                  <div class="form-label-group">
                    <input 
                      type="text" 
                      class="form-control address colorBorde" 
                      v-model="atencion" 
                      placeholder="Atencion a" 
                      autofocus>
                    <label>Atencion a:</label>
                  </div>
                </b-col>
              </b-row>
              <b-row align-v="center" class="mb-1">
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                  <div class="form-label-group">
                    <input 
                      type="text" 
                      class="form-control address colorBorde"  
                      v-model="plazoentrega" 
                      placeholder="Plazo de entrega" 
                      autofocus>
                    <label>Plazo de entrega:</label>
                  </div>
                </b-col>
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                  <div class="form-label-group">
                    <input 
                      type="text" 
                      class="form-control address colorBorde" 
                      v-model="formapago" 
                      placeholder="Forma de pago" 
                      autofocus>
                    <label>Forma de pago:</label>
                  </div>
                </b-col>
              </b-row>
              <b-row align-v="center">
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                  <div class="form-label-group">
                    <input 
                      type="text" 
                      class="form-control address colorBorde" 
                      v-model="garantia" 
                      placeholder="Garantia" 
                      autofocus>
                    <label>Garantia:</label>
                  </div>
                </b-col>
                <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                  <div class="form-label-group">
                    <input 
                      type="text" 
                      class="form-control address colorBorde" 
                      v-model="telefono" 
                      placeholder="Teléfono" 
                      autofocus>
                    <label>Teléfono:</label>
                  </div>
                </b-col>
              </b-row>
            </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <items @captureitem="insertItem" :dataitem="dataitem" :igvGlobal="igvGlobal"></items>  
      </b-col>  
    </b-row>    
    <b-row>
        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
            <template>
                <div>
                  <b-table responsive
                    :small="small"
                    :striped="striped"
                    :outlined="outlined"
                    :items="items"
                    :fields="fields"
                    >
                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                    <template slot="valorVentaVista" slot-scope="row">
                      {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}
                    </template>
                    <template slot="descripcion" slot-scope="row">
                      <b-form-textarea
                        id="textarea"
                        v-model="row.item.descripcion"
                        placeholder="Enter something..."
                        rows="3"
                        max-rows="6"
                      ></b-form-textarea>
                    </template>
                    <template slot="precioUnitario" slot-scope="row">
                      {{ row.item.precioVentaUnitario }}
                    </template>
                    <template slot="acciones" slot-scope="row">
                      <b-button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></b-button>
                      <b-button class="btn btn-sm btn-group btn-outline-danger" @click="deleteItem(row.index)"><i class="fa fa-trash danger"></i></b-button>
                    </template>
                    <template slot="muestraIgv" slot-scope="row">
                      <p style="color:red; font-size:10px;margin:0px;padding: 0px;">{{ row.item.porcentajeImpuesto }}%</p>
                    </template>
                  </b-table>
                </div>
            </template>
        </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col cols="0" sm="0"	md="8"	lg="8"	xl="8">
        <b-form-textarea      
          v-model="observaciones"
          rows="3"
          max-rows="6"
          class="textareaproforma colorBorde" 
          placeholder="Observaciones... ">
        </b-form-textarea>
      </b-col>
      <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
        <totales @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :identificadorPro="identificadorPro"></totales>
      </b-col>
    </b-row>
    <b-row>
          <b-col cols="4" sm="6"	md="8"	lg="8"	xl="9"></b-col>
          <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
            <template v-if="update">
              <button v-if="!cargandoproforma" :disabled="validateProforma()" class="btn btn-primary botonesemitir" @click="sendProforma()"><i class="fa fa-save"></i> Guardar</button>
              <button v-else class="btn btn-seconday botonesemitir"><i class="fa fa-spin fa-spinner"></i> Guardando... </button>
            </template>
            <template v-else>
              <button v-if="!actualizandoproforma" class="btn btn-warning botonesemitir" @click="updateProforma()"><i class="fa fa-save"></i> Actualizar</button>
              <button v-else class="btn btn-seconday botonesemitir"><i class="fa fa-spin fa-spinner"></i> Actualizando... </button>
            </template>
          </b-col>
    </b-row>
    </b-card>
    <vue-snotify></vue-snotify>
   </div>
</template>

<script>
import axios from 'axios'
import Inputext from '@/components/comunes/Input'
import Items from '@/components/comunes/Items'
import Totales from '@/components/comunes/Totales'
import { TipoMoneda } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
    export default {
        name: 'ProformaEmision',
        props: ['changeProforma','emitirProforma'],
        components:{
          Items,
          Totales,
          Inputext,
          Datepicker
        },
        data: () => {
            return {
              dataplace: 'Atencion a',
              direcciones: [],
              listaCorreos: [],
              verDirecciones: false,
              documentosIdentidad: DocumentosIdentidad,
              tipoDocumento: '6',
              small: true,
              striped: true,
              outlined: true,
              update: true,
              tipoMoneda: TipoMoneda,
              cargandoreceptor: false,
              receptor: {
                  numero:'',
                  tipo:'6',
                  direccion:'',
                  razonSocial:'',
                  direccionFiscal: ''
              },
              moneda: {
                id: '1',
                codigo: 'PEN',
                descripcion: 'SOLES',
                simbolo: 'S/.'
              },
              condicionpago: '',
              plazoentrega: '',
              formapago: '',
              garantia: '',
              telefono: '',
              atencion: '',
              observaciones: '',
              serie: '',
              numero: '',
              captureitem: false,
              proforma: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {
                  tipo_igv:''
                },
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: ''
              },
              fields: [
                  {key: 'index', label: 'N°'},
                  {key: 'cantidad', label: 'Cantidad', sortable: true},
                  {key: 'descripcion', label: 'Descripción', sortable: true},
                  {key: 'precioUnitario', label: 'Precio Unitario', sortable: true},
                  {key: 'valorUnitarioVista', label: 'Valor Unitario', sortable: true},
                  {key: 'descuento', label: 'Descuento', sortable: true},
                  {key: 'montoAfectacionIgv', label: 'Igv', sortable: true},
                  {key: 'valorVentaVista', label: 'Precio Total', sortable: true},
                  {key: 'acciones', label: 'Acciones', sortable: true},
                  {key: "muestraIgv", label: "", sortable: true } 
              ],
              items: [],
              dataitem: {
                estado: false,  // Bandera logica de si se esta usando este arreglo
                tipo: 1,        // 1: actualizar; 2: borrar; 3: cargar masiva
                index: 0,       // Posicion en el array para actualizar o borrar
                // data: [],        // Lista de items
                item: {},
                // ordencompra: 0,
                idReceptor: ''
              },
              totales: {},
              rucValid: null,
              listarec: true,
              listaReceptores: [],
              listaSeries: [],
              indexSerie: 0,
              tipodoc: '10',
              seriesCargadas: false,
              cargandoproforma: false,
              actualizandoproforma: false,
              idProforma: '',
              mostrardni:false,
              norecdni:false,
              listadni:[],
              customers:[],
              identificadorPro: 0,
              igvGlobal: null,
              fechaEmision:'',
              es: es,
              diasnopermitidos: {
                ranges: []
              },
              currentdate: "",
              fechaEmisionProforma:''
            }
        },
        mounted () {
          this.initChangeProforma(),
          this.clonandoProforma(),
          this.getSeries(),
          this.initDates();
        },
        watch: {
          'receptor.numero': function () {
            if(this.receptor.numero == ''){
              this.receptor.numero = ''
              this.receptor.razonSocial = ''
              this.receptor.direccion = ''
              this.receptor.direccionFiscal = ''
              this.listarec = false
            }
          }
        },
        methods: {
          getSeries: function () {
            this.identificadorPro
            this.seriesCargadas = true
              axios
              .post(process.env.VUE_APP_API_URL + 'usuario/series/8', {
                  token: this.$store.getters.userToken
              })
              .then(response => (
                  this.listaSeries = response.data.data, 
                  this.rolSeries = response.data.rol,
                  this.seriesCargadas = false,
                  this.igvGlobal = response.data.igv
                  ))
              .catch(error => {
                  this.seriesCargadas = false
              })
          },
          customFormatter: function(date) {
            return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");      
          },
          initDates: function() {
               let r1 = {
              from: this.$moment().subtract(50000, "years"), //desde
              to: this.$moment().subtract(50000, "days")
              };
              let r2 = {
              from: this.$moment().add(50000, "days"), //hasta
              to: this.$moment().add(60000, "years")
              };
              this.diasnopermitidos.ranges.splice(r1);
              this.diasnopermitidos.ranges.splice(r2);
              this.diasnopermitidos.ranges.push(r1);
              this.diasnopermitidos.ranges.push(r2);
              this.currentdate = this.$moment().format("YYYY-MM-DD HH:mm:ss"); 
            },
          changeText: function (value) {
            this.atencion = value
          },
          initItems: function() {
            let itemBlank = []
            this.$store.commit('setitems', itemBlank)
          },
          validateProforma: function () {
            let tiposerie = ''
            if(this.indexSerie == 0){
              this.serie = this.listaSeries[0]
              tiposerie = this.serie
            }else{
              this.serie = this.listaSeries[this.indexSerie]
              tiposerie = this.serie
            }
            if(this.tipoDocumento=='0' && this.items.length > 0 && tiposerie!=''){
              return false
            }else{
              if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.items.length > 0 && tiposerie!==''){
                return false
              }else{
                return true
              }
            }
          },
          setDirection: function (value) {
            this.receptor.direccion = value.direccion,
            this.verDirecciones = false
          },
          enableFieldsReceptor: function () {
            this.habilitado = false
          },
          changeDirection: function () {
            this.verDirecciones = !this.verDirecciones
          },
          initChangeProforma: function () {
            let validatobjeto = false
            Object.keys(this.changeProforma).length === 0 ? validatobjeto = true: validatobjeto = false
            if(!validatobjeto){
              this.tipoDocumento = this.changeProforma.proforma.receptor.tipo
              if(this.changeProforma.proforma.receptor.nro == null){
                this.receptor.numero =  '-'
              }else{
                this.receptor.numero =  this.changeProforma.proforma.receptor.nro
              }
              //this.receptor.numero =  this.changeProforma.proforma.receptor.nro,
              this.receptor.razonSocial =  this.changeProforma.proforma.receptor.razonSocial,
              this.receptor.direccion =  this.changeProforma.proforma.receptor.direccionFiscal,
              this.idProforma = this.changeProforma.idProforma,
              this.plazoentrega =  this.changeProforma.proforma.plazoentrega,
              this.formapago =  this.changeProforma.proforma.formapago,
              this.atencion = this.changeProforma.proforma.atencion,
              this.observaciones = this.changeProforma.proforma.observaciones,
              this.garantia =  this.changeProforma.proforma.garantia,
              this.telefono =  this.changeProforma.proforma.telefono,
              this.moneda = this.changeProforma.proforma.moneda
              this.items =  this.changeProforma.proforma.items,
              this.$store.commit('setitems', this.items),
              this.dataitem.estado = false,
              this.dataitem.tipo = 3,
              this.dataitem.index = 0,
              this.update = false
            }else if(this.changeProforma == '0'){
              this.update = true,
              this.initProforma(),
              this.initItems()
            }
          },
            clonandoProforma: function () {
            let validatobjeto = false
            Object.keys(this.emitirProforma).length === 0 ? validatobjeto = true: validatobjeto = false
            if(!validatobjeto){
              this.tipoDocumento = this.emitirProforma.proforma.receptor.tipo,
              this.receptor.numero =  this.emitirProforma.proforma.receptor.nro,
              this.receptor.razonSocial =  this.emitirProforma.proforma.receptor.razonSocial,
              this.receptor.direccion =  this.emitirProforma.proforma.receptor.direccionFiscal,
              this.idProforma = this.emitirProforma.idProforma,
              this.plazoentrega =  this.emitirProforma.proforma.plazoentrega,
              this.formapago =  this.emitirProforma.proforma.formapago,
              this.atencion = this.emitirProforma.proforma.atencion,
              this.observaciones = this.emitirProforma.proforma.observaciones,
              this.garantia =  this.emitirProforma.proforma.garantia,
              this.telefono =  this.emitirProforma.proforma.telefono,
              this.items =  this.emitirProforma.proforma.items
              this.$store.commit('setitems', this.items)
            }else if(this.emitirProforma == '0'){
              this.initProforma(),
              this.initItems()
            }
          },
          insertItem: function (value) {
            this.$store.commit('setitems', value)
            this.items = this.$store.getters.getitems
            this.dataitem.tipo = 3
            this.dataitem.estado = false
          },
          insertTotal: function (value) {
            if(value){
              this.totales = value
            }
          },
          updateItem: function (index, item) {
            this.dataitem.estado = true
            this.dataitem.tipo = 1
            this.dataitem.index = index
            this.dataitem.item = item
          },
          deleteItem: function (index) {
            this.dataitem.estado = true
            this.dataitem.tipo = 2
            this.dataitem.index = index
            this.dataitem.idReceptor = this.receptor.numero;
          },
          sendProforma: function () {
            let itemBlank = []
            this.cargandoproforma = true
            if(this.loadProforma()){
              axios
              .post(process.env.VUE_APP_API_URL + 'proformas/insertar', {
                  token: this.$store.getters.userToken,
                  serie: this.serie,
                  proforma: this.proforma
              })
              .then(response => (
                this.$snotify.success(response.data.msg,'Exito'),
                this.cargandoproforma = false,
                this.initProforma(),
                this.changeTab(1),
                this.$store.commit('setitems', itemBlank)
              ))
              .catch(error => {
                this.cargandoproforma = false,
                this.$snotify.error(error.response.data.msg,'Error')
              })
            }
          },
          loadProforma: function () {
            this.proforma.receptor.tipo = this.tipoDocumento
            this.proforma.receptor.nro = this.receptor.numero
            this.proforma.receptor.razonSocial = this.receptor.razonSocial
            this.proforma.receptor.direccionFiscal = this.receptor.direccion
            if(this.fechaEmisionProforma == ''){
              this.proforma.fechaEmision = this.currentdate
            }else{
              this.proforma.fechaEmision = this.$moment(this.fechaEmisionProforma).format("YYYY-MM-DD HH:mm:ss")
            }
            this.proforma.moneda = this.moneda
            this.proforma.plazoentrega = this.plazoentrega
            this.proforma.formapago = this.formapago
            this.proforma.garantia = this.garantia
            this.proforma.telefono = this.telefono
            this.proforma.items = this.items
            this.proforma.totales = this.totales
            this.proforma.atencion = this.atencion
            this.proforma.observaciones = this.observaciones
            this.proforma.adicional.username = this.$store.getters.userData.username
            this.proforma.adicional.tipo_igv = this.igvGlobal
            return true
          },
          initProforma: function () {
            this.proforma.receptor.tipo = ''
            this.proforma.receptor.nro = ''
            this.proforma.receptor.razonSocial = ''
            this.proforma.receptor.direccionFiscal = ''
            this.proforma.fechaEmision = ''
            this.proforma.moneda = ''
            this.proforma.plazoentrega = ''
            this.proforma.formapago = ''
            this.proforma.garantia = ''
            this.proforma.telefono = ''
            this.proforma.atencion = ''
            this.proforma.observaciones = ''
            this.proforma.adicional = {}
            this.tipoDocumento = '0'
            return true
          },
          updateProforma: function () {
            this.actualizandoproforma = true,
            this.loadProforma()
            axios
            .post(process.env.VUE_APP_API_URL + 'proformas/actualizar', {
                token: this.$store.getters.userToken,
                id: this.idProforma,
                proforma: this.proforma
            })
            .then(response => (
              this.actualizandoproforma = false,
              this.$snotify.success(response.data.msg,'Exito'),
              this.initProforma(),
              this.changeTab(1)
            ))
            .catch(error => {
              this.actualizandoproforma = false,
              this.$snotify.error(error.response.data.msg,'Error')
            })
          },
          printProforma: function () {

          },
          getReceivers: function (value) {
              this.cargandoreceptor = true
              this.listarec = true
              this.listaReceptores = []
              let link = ''
              let cadenabusqueda = ''
              if(value === 1){
                  link = 'receptores/listaconterceros',
                  cadenabusqueda = this.receptor.numero
              }else if(value === 2){  
                  link = 'receptores/listaconterceros/razonsocial'
                  cadenabusqueda = this.receptor.razonSocial
              }
              axios
              .post(process.env.VUE_APP_API_URL + link,{
                  token: this.$store.getters.userToken,
                  q: cadenabusqueda,
                  tipoRec: this.tipoDocumento
              })
              .then(response => (
                  this.listaReceptores = response.data,
                  this.cargandoreceptor = false,
                  this.receivercount(this.listaReceptores.length)                                      
              ))
              .catch(error => (
                  this.cargandoreceptor = false
              ))           
          },
          listTerceros: function(item) {
            axios
              .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                token: this.$store.getters.userToken,
                page: this.currentPageTerceros,
                order: this.ordenTerceros
              })
              .then(response =>(
                  this.customers = response.data,
                  this.validarObs(item)
                ))
              .catch(error => (
                console.log(error)
              ))
          },
          validarObs(item){
            let valorOBS = ''
            this.customers.forEach(function(element){
              if(item.idReceptor == element.documento){
                element.obsDocs.forEach(function(element){
                  if(element.doc == 'Proforma'){
                      valorOBS = element.obs
                  }
                })
              }    
            })
            this.observaciones = valorOBS
          },
          setReceiver: function (item) {
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarec = false,
            this.listaReceptores = [],
            this.tipoDocumento = item.tipo,
            this.listTerceros(item) 
          },
          addReceiver: function (value) {
            if(value.length == 0){
              this.modalCliente = true
            }else{
              this.modalCliente = false
            } 
          },
          receivercount: function (value){
            if(!value)
            {   
                this.listarec = false
                 setTimeout(() => this.searchDNI(),1000);       
            }
            else
            {
                this.listarec = true
            }
          },
          searchDNI(){
            this.cargandoreceptor = true
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.receptor.numero
                }
            })
            .then(response => (
                    this.listadni = response.data,
                    this.cargandoreceptor = false,
                    this.receivedni(this.listadni)
            ))
            .catch(error => (
                this.cargandoreceptor = false
            ))    
            
          }, 
          receivedni: function (value){
             if(!value)
            {
                this.mostrardni = false
            }
            else
            {
                this.mostrardni = true,
                this.setReceiverdni(this.listadni)
            }
          },
         setReceiverdni(item){
            this.receptor.razonSocial = item.nombre
            this.mostrardni = false
            this.listarec = false
            this.listaReceptores = []
          },
          stateReceptorRuc (value) {
            let expreg = new RegExp('\\s|<|>|[A-Za-z]|^[3-9]|^[0]')
            if(value.length == 0){
              // this.$snotify.error('RUC Inválido','Error');
              this.rucValid = false
            } else if (expreg.test(value)) {
              this.$snotify.error('RUC Inválido','Error');
              this.rucValid = false
            } else {        
                this.rucValid = true       
            }
          },
          changeTab: function (value){
            this.$emit("tabindex", value);
          }
        }
    }
</script>

<style scoped>
    .btnguardar{
        margin-right: 10px;
    }
    .textareaproforma{
      background-color: #fff;
      border: 1px solid #ccc;
      border-radius: 5px;
      color: #000;
    }
    .address{
      height: 35px !important;
      margin: 0 !important;
    }
</style>

<style scoped>
  .form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}

.form-label-group > input,
.form-label-group > label {
  height: 3.125rem;
  padding: .75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 9px;
  color: #00B261;
}
.colorBorde{
  border-color:#7e8fb9;
}
</style>